import React, { useState } from 'react';
// import { phone } from 'phone';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

// import { doSignupRequest } from '../../../../store/action/auth';
// import Phone from '../../../../ui-core/Phone';
import Button from '../../../../ui-core/Button/Button';
import Ref from '../../../../ui-core/Ref';
import { MODAL_TYPE } from '../../../../constants/app';
// import { SEGMENT_EVENTS, trackEvent } from '../../../../utils/Segment';
// import AppleLogin from '../../../../components/AppleLogin';
import GoogleLogin from '../../../../components/GoogleLogin';
import AppleLogin from '../../../../components/AppleLogin';
// import { grecaptcha } from '../../../../services/recaptcha';

import './style.css';
// import { APP_ROUTES } from '../../../../route';
import EmailIcon from '../../../../static/images/signup/Email.svg';
import OpenEye from '../../../../static/images/signup/Openeye.svg';
import CloseEye from '../../../../static/images/signup/closeeye.svg';
// import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { SEGMENT_EVENTS, trackEvent } from '../../../../utils/Segment';
import { setItem } from '../../../../utils/cache';
import { doOtpRequest, doSignupRequest } from '../../../../store/action/auth';
import { grecaptcha } from '../../../../services/recaptcha';

const SignUp = props => {
  // const [postData, setPostData] = useState({
  //   mobile: null,
  //   country_code: null,
  // });
  // const [isValidNumber, setValidNumber] = useState(false);
  const { isLoading } = useSelector(state => state.common);
  // const [error, setError] = useState({ hasError: false, message: '' });
  // const [, setBtnVisible] = useState({
  //   isVisible: false,
  // });
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  // const [isPageLoading, setIsPageLoading] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { handleModalState } = props;

  const head = <h2 className="sign-in-h1">Sign Up </h2>;

  // const handlePhoneOnChange = (phoneNumber, countryCode, countryData) => {
  //   const validData = phone(
  //     `${countryCode}${phoneNumber?.replace(/\D+/g, '')}`,
  //     { country: countryData?.countryCode?.toUpperCase() },
  //   );
  //   setValidNumber(validData.isValid);
  //   setPostData({
  //     mobile: phoneNumber?.replace(/\D+/g, ''),
  //     country_code: countryCode,
  //   });
  //   if (phoneNumber[0] === '0') {
  //     setError({
  //       ...error,
  //       hasError: true,
  //       message: '0 cannot be the first digit of your mobile number.',
  //     });
  //   } else if (phoneNumber[0] === '(' && phoneNumber[1] === '0') {
  //     setError({
  //       ...error,
  //       hasError: true,
  //       message: '0 cannot be the first digit of your mobile number.',
  //     });
  //   } else if (!validData.isValid) {
  //     setError({
  //       ...error,
  //       hasError: true,
  //       message: 'Please enter a valid number.',
  //     });
  //   } else {
  //     setError({ ...error, hasError: false, message: '' });
  //   }
  // };

  // const handlePhoneOnSubmit = e => {
  //   e.preventDefault();
  //   grecaptcha.execute(token => {
  //     // trackSubmittedEvent('Sign up submit', {
  //     //   page: 'Home Page',
  //     //   section_title: 'Signup Modal',
  //     //   button_title: 'SEND VERIFICATION CODE',
  //     //   phone: postData?.mobile,
  //     //   country_code: postData?.country_code,
  //     // });
  //     dispatch(
  //       doSignupRequest({
  //         data: {
  //           ...postData,
  //           type: 'signup',
  //           token,
  //         },
  //         callback: () => handleModalState(MODAL_TYPE.OTP),
  //         page: props.page,
  //       }),
  //     );
  //     // trackDisplayedEvent('Display OTP Modal', {
  //     //   page: 'Home Page',
  //     //   section_title: 'OTP Modal',
  //     // });
  //   });
  // };

  const handleLoginClick = () => {
    handleModalState(MODAL_TYPE.LOGIN);
    trackEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
      // eslint-disable-line
      button_title: 'Login Now',
      page: props.page || 'Home Page',
      section_title: `Sign up Modal`,
    });
    // trackDisplayedEvent('Display Login Modal', {
    //   page: 'Home Page',
    //   section_title: 'Login Modal',
    // });
  };

  // const handleKeyDown = event => {
  //   if (event.keyCode === 13 && isValidNumber) handlePhoneOnSubmit(event);
  // };
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      // .email('Please enter valid email.')
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        `You've entered an invalid email, please try another one.`,
      )
      .required('Please enter email.'),
    password: Yup.string()
      .required('Please enter password.')
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d\s]).{8,}$/,
        'Password must be at least 8 characters, contain at least one uppercase letter, one lowercase letter, one number, and one special character.',
      ),
    confirmPassword: Yup.string()
      .required('Please enter confirm password.')
      .oneOf(
        [Yup.ref('password'), null],
        'Password and confirm password must be the same.',
      ),
  });

  // NEW - working
  const onSubmit = async values => {
    setIsDisabled(true);
    setItem('isFromLogin', Boolean(false));

    const payload = {
      email: values.email.toLowerCase(),
      password: values.password,
      email_signin: true,
    };

    try {
      const token = await new Promise((resolve, reject) => {
        grecaptcha.execute(token => {
          if (token) resolve(token);
          else reject(new Error('reCAPTCHA token not received'));
        });
      });

      // Wrap the entire flow in a Promise
      await new Promise((resolve, reject) => {
        dispatch(
          doSignupRequest({
            data: {
              email: values?.email.toLowerCase(),
              password: values?.password,
              email_signup: true,
              type: 'signup',
              token,
            },
            callback: async () => {
              try {
                await dispatch(
                  doOtpRequest({
                    data: payload,
                    callback: async () => {
                      await handleModalState(MODAL_TYPE.PHONE);
                      resolve(); // Resolve only after success
                    },
                    errorCallback: async () => {
                      await handleModalState(MODAL_TYPE.SIGNUP);
                      resolve(); // Still resolve to let finally run
                    },
                  }),
                );
              } catch (err) {
                reject(err); // Reject if anything fails in OTP dispatch
              }
            },
            errorCallback: async err => {
              console.error('Signup API failed', err);
              reject(err); // Trigger catch block
            },
            page: props.page,
          }),
        );
      });
    } catch (error) {
      console.error('Error in signup flow:', error);
    } finally {
      setIsDisabled(false);
    }
  };

  // Old 2

  // const onSubmit = async (values) => {
  //   setIsDisabled(true);
  //   console.log("onSubmit isLoading", isLoading);

  //   setItem('isFromLogin', Boolean(false));

  //   const payload = {
  //     email: values.email,
  //     password: values.password,
  //     email_signin: true,
  //   };

  //   try {
  //     const token = await new Promise((resolve, reject) => {
  //       grecaptcha.execute((token) => {
  //         if (token) resolve(token);
  //         else reject(new Error("reCAPTCHA token not received"));
  //       });
  //     });

  //     await dispatch(
  //       doSignupRequest({
  //         data: {
  //           email: values?.email,
  //           password: values?.password,
  //           email_signup: true,
  //           type: 'signup',
  //           token,
  //         },
  //         callback: async () => {
  //           await dispatch(
  //             doOtpRequest({
  //               data: payload,
  //               callback: async () => {
  //                 await handleModalState(MODAL_TYPE.PHONE);
  //               },
  //               errorCallback: async () => {
  //                 await handleModalState(MODAL_TYPE.SIGNUP);
  //               },
  //             })
  //           );
  //         },
  //         page: props.page,
  //       })
  //     );
  //   } catch (error) {
  //     console.error("Error in signup flow:", error);
  //   }
  //   finally {
  //     setIsDisabled(false);
  //   }
  // };

  // OLD // Not working due to comment in JW-275

  // const onSubmit = async (values) => {
  //   setIsDisabled(true);
  //   console.log("onSubmit isLoading", isLoading);

  //   setItem('isFromLogin', Boolean(false));

  //   const payload = {
  //     email: values.email,
  //     password: values.password,
  //     email_signin: true,
  //   };
  //   // localStorage.setItem('SignUpData', JSON.stringify(payload));
  //   // handleModalState(MODAL_TYPE.PHONE);
  //   // setIsPageLoading(true);
  //   try {
  //     grecaptcha.execute(async (token) => {
  //       await dispatch(
  //         doSignupRequest({
  //           data: {
  //             email: values?.email,
  //             password: values?.password,
  //             email_signup: true,
  //             type: 'signup',
  //             token,
  //           },
  //           callback: async () => {
  //             dispatch(
  //               doOtpRequest({
  //                 data: payload,
  //                 callback: async () => {
  //                   handleModalState(MODAL_TYPE.PHONE);
  //                   // setIsPageLoading(false);
  //                 },
  //                 errorCallback: async () => {
  //                   await handleModalState(MODAL_TYPE.SIGNUP);
  //                   // setIsPageLoading(false);
  //                 },
  //               }),
  //             )
  //           },
  //           page: props.page,
  //         }),
  //       );
  //     });
  //   }
  //   catch (error) {
  //     console.log(error);
  //   }
  //   finally {
  //     setIsDisabled(false);
  //   }
  //   // setIsPageLoading(false);
  // };

  const { errors, handleSubmit, setFieldValue, touched } = useFormik({
    validationSchema,
    onSubmit,
    initialValues: {
      email: '',
      password: '',
      confirmPassword: '',
    },
  });
  return (
    // <div className="form-h">
    //   {head}
    //   <p className="sign-in-h3 text-center mb-4 mt-4 pb-3">
    //     Signup with your mobile number
    //   </p>
    //   <Phone
    //     countryCode={countryCode}
    //     handleOnChange={handlePhoneOnChange}
    //     setBtnVisible={setBtnVisible}
    //     onKeyDown={handleKeyDown}
    //   />
    //   <div className="position-relative">
    //     <span className="text-danger error-text text-center d-block w-100">
    //       {error.hasError ? error.message : ''}
    //     </span>
    //   </div>
    //   <Button
    //     text="SEND VERIFICATION CODE"
    //     // TODO: we need to add 'spinner-border text-white'
    //     class={`OtpButton ${isLoading && ''}`}
    //     isDisabled={isLoading || !isValidNumber}
    //     isLoading={isLoading}
    //     onClick={handlePhoneOnSubmit}
    //   />
    //   <p className="new-sign-in-para">or</p>
    //   <div className="d-flex align-items-center justify-content-center">
    //     {/* <AppleLogin isLoading={isLoading} section={'Signup'} /> */}
    //     <GoogleLogin
    //       isLoading={isLoading}
    //       section={'Signup'}
    //       plan_id={props.plan_id}
    //     />
    //   </div>
    //   <div className="d-flex align-items-center justify-content-center">
    //     <AppleLogin
    //       isLoading={isLoading}
    //       section={'Signup'}
    //       plan_id={props.plan_id}
    //       handleModalState={handleModalState}
    //     />
    //   </div>
    //   <div className="d-flex align-items-center justify-content-center signin-bottom-row mt-4">
    //     <h3 className="head3 m-0"> Already a member ? </h3>
    //     <Ref
    //       class="signup-link fz20 ms-2"
    //       onClick={() => handleLoginClick()}
    //       text="Login Now"
    //     />
    //   </div>
    //   <div className="sign-in-agreement d-flex align-items-center flex-wrap justify-content-center">
    //     <h4>By continuing, you agree to Jen&apos; s</h4>
    //     <div className="d-flex align-items-center mb_d">
    //       <a
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         href="https://docs.google.com/document/d/1d2nS643SoO95afqaKZtL7EHxClNoACPsiFeqevS7PGQ/edit"
    //         className="d-inline-block mx-1"
    //       >
    //         Terms of service
    //       </a>
    //       <h3>and </h3>
    //       <a
    //         className="d-inline-block mx-1"
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         href={window.location.origin + APP_ROUTES.PRIVACY_POLICY}
    //       >
    //         Privacy policy
    //       </a>
    //     </div>
    //   </div>
    // </div>
    <div className="form-h">
      {head}
      <p className="sign-in-h3 mt-4 pb-2">
        Please enter your details to create your account.
      </p>
      <form onSubmit={handleSubmit}>
        <div className="email_input">
          <label htmlFor="email" className="text-uppercase sign_label">
            EMAIL ADDRESS
          </label>
          <div className="mt-2 email_input_text d-flex gap-0">
            <img src={EmailIcon} alt="email icon" />
            <input
              type="text"
              name="email"
              id="email"
              className="border-0 ms-2 w-100 sign_up_input"
              placeholder="Enter email"
              onChange={event => setFieldValue('email', event.target.value)}
            />
          </div>
          {!!errors?.email && !!touched?.email && (
            <span className="text-danger error-text">{errors?.email}</span>
          )}
        </div>
        <div className="pass_input mt-4">
          <label htmlFor="password" className="text-uppercase sign_label">
            Enter Password
          </label>
          <div className="mt-2 pass_input_text">
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              id="password"
              className="border-0 w-100 sign_up_input"
              placeholder="Enter password"
              onChange={event => setFieldValue('password', event.target.value)}
            />
            <div onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? (
                <img src={OpenEye} alt="show icon" />
              ) : (
                <img src={CloseEye} alt="hide icon" />
              )}
            </div>
          </div>
          {!!errors?.password && !!touched?.password && (
            <div className="text-danger error-text">{errors?.password}</div>
          )}
        </div>
        <div className="pass_input mt-4">
          <label
            htmlFor="confirmPassword"
            className="text-uppercase sign_label"
          >
            Confirm password
          </label>
          <div className="mt-2 pass_input_text">
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              name="confirmPassword"
              id="confirmPassword"
              className="border-0 w-100 sign_up_input"
              placeholder="Confirm password"
              onChange={event =>
                setFieldValue('confirmPassword', event.target.value)
              }
            />
            <div onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
              {showConfirmPassword ? (
                <img src={OpenEye} alt="show icon" />
              ) : (
                <img src={CloseEye} alt="hide icon" />
              )}
            </div>
          </div>
          {!!errors?.confirmPassword && !!touched?.confirmPassword && (
            <span className="text-danger error-text">
              {errors?.confirmPassword}
            </span>
          )}
        </div>
        <p className="sign-up-tc mt-4">
          By continuing, you agree to Jen ‘s{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://docs.google.com/document/d/1d2nS643SoO95afqaKZtL7EHxClNoACPsiFeqevS7PGQ/edit"
          >
            Terms of service
          </a>{' '}
          and{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://jen.health/privacypolicy"
          >
            Privacy Policy
          </a>
        </p>
        <Button
          text="CONTINUE"
          // TODO: we need to add 'spinner-border text-white'
          class={`OtpButton ${isLoading && ''}`}
          isLoading={isLoading}
          isDisabled={isLoading || isDisabled}
        />
      </form>
      <div className="divider-container mt-3">
        <div className="line"></div>
        <span className="text">OR WITH</span>
        <div className="line"></div>
      </div>
      <div className="social-btn w-100 gap-1 gap-md-3 flex-md-row">
        <GoogleLogin
          isLoading={isLoading}
          section={'Signup'}
          plan_id={props.plan_id}
          className="w-100"
        />
        <AppleLogin
          isLoading={isLoading}
          section={'Signup'}
          plan_id={props.plan_id}
          handleModalState={handleModalState}
          className="w-100"
        />
      </div>
      <div className="d-flex align-items-center justify-content-center signin-bottom-row mt-4">
        <h3 className="head3 m-0"> Already a member? </h3>
        <Ref
          class="signup-link fz20 ms-2"
          onClick={() => handleLoginClick()}
          text="Login Now"
        />
      </div>
    </div>
  );
};

SignUp.propTypes = {
  // countryCode: PropTypes.string,
  handleModalState: PropTypes.func,
  page: PropTypes.string,
  plan_id: PropTypes.string,
};

export default SignUp;
